/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconSearchAlertActivated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconSearchAlertActivated"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.99 3.58a9 9 0 0 0-5.71 6.157l1.93.518a7 7 0 0 1 4.446-4.79zM18.798 6.208a9 9 0 0 1 1.868 8.188l-1.932-.518c.62-2.311 0-4.67-1.455-6.37z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m14.32 7.172.54-2.02-1.932-.517-.54 2.02a5.5 5.5 0 0 0-5.747 4.06L5.476 15.06l-1.932-.517-.518 1.932 5.245 1.405a2.071 2.071 0 0 0 4 1.072l5.244 1.405.518-1.932-1.932-.518 1.165-4.346a5.5 5.5 0 0 0-2.947-6.39"
      clipRule="evenodd"
    />
  </svg>
);
export default IconSearchAlertActivated;
